var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <a class=\"B5-4-column-content__column-inner\" href=\""
    + container.escapeExpression(((helper = (helper = lookupProperty(helpers,"link") || (depth0 != null ? lookupProperty(depth0,"link") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"link","hash":{},"data":data,"loc":{"start":{"line":3,"column":53},"end":{"line":3,"column":61}}}) : helper)))
    + "\">\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "	<figure class=\"B5-4-column-content__image\">\n		"
    + ((stack1 = lookupProperty(helpers,"block").call(depth0 != null ? depth0 : (container.nullContext || {}),"image",{"name":"block","hash":{},"data":data,"loc":{"start":{"line":8,"column":2},"end":{"line":8,"column":21}}})) != null ? stack1 : "")
    + "\n	</figure>\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(helpers,"content").call(alias1,"icon",{"name":"content","hash":{},"data":data,"loc":{"start":{"line":10,"column":11},"end":{"line":10,"column":27}}}),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":10,"column":1},"end":{"line":14,"column":1}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "	<figure class=\"B5-4-column-content__icon\">\n		"
    + ((stack1 = lookupProperty(helpers,"block").call(depth0 != null ? depth0 : (container.nullContext || {}),"icon",{"name":"block","hash":{},"data":data,"loc":{"start":{"line":12,"column":2},"end":{"line":12,"column":20}}})) != null ? stack1 : "")
    + "\n	</figure>\n	";
},"8":function(container,depth0,helpers,partials,data) {
    return "		Title Line 1<br>Title Line 2\n";
},"10":function(container,depth0,helpers,partials,data) {
    return "		Vestibulum rutrum quam vitae fringilla tincidunt. Suspendisse nec tortor urna. Ut.\n";
},"12":function(container,depth0,helpers,partials,data) {
    return "  </a>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<section class=\"B5-4-column-content__column\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"link") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":2},"end":{"line":4,"column":9}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(helpers,"content").call(alias1,"image",{"name":"content","hash":{},"data":data,"loc":{"start":{"line":6,"column":7},"end":{"line":6,"column":24}}}),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.program(5, data, 0),"data":data,"loc":{"start":{"line":6,"column":1},"end":{"line":14,"column":8}}})) != null ? stack1 : "")
    + "\n	<h2 class=\"B5-4-column-content__column-title\">\n"
    + ((stack1 = lookupProperty(helpers,"block").call(alias1,"title",{"name":"block","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":17,"column":1},"end":{"line":19,"column":11}}})) != null ? stack1 : "")
    + "	</h2>\n\n	<p class=\"B5-4-column-content__copy\">\n"
    + ((stack1 = lookupProperty(helpers,"block").call(alias1,"text",{"name":"block","hash":{},"fn":container.program(10, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":1},"end":{"line":25,"column":11}}})) != null ? stack1 : "")
    + "	</p>\n\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,(depth0 != null ? lookupProperty(depth0,"link") : depth0),{"name":"if","hash":{},"fn":container.program(12, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":28,"column":2},"end":{"line":30,"column":9}}})) != null ? stack1 : "")
    + "</section>\n";
},"useData":true});